import React, { useEffect, useState } from 'react';
import IBuildrProps from 'src/utilities/IBuildrProps';
import classNames from 'classnames';
import { IFrame } from '../IFrame';
import HttpService from '../../services/HttpService';

export interface IScheduleAppointmentProps extends IBuildrProps { }

interface BranchData {
    branch_id: string;
    timetrade_code: string;
}

export function ScheduleAppointment({ cmsId, editorClassObj }: IScheduleAppointmentProps) {
    const [iframeOptions, setIframeOptions] = useState(null);

    useEffect(() => {
        async function loadIframe() {
            setIframeOptions(await getIFrameOptions());
        }
        if (window) {
            loadIframe();
        }
    }, []);

    return (
        <div data-id={cmsId} className={classNames(editorClassObj)}>
            { iframeOptions ?
                <IFrame src={iframeOptions.src} allow="geolocation" style={{ width: "100%", height: "100%", minHeight: "800px", border: "none" }} />
                :
                null
            }

        </div>
    );
}

async function getBranchesMappings() {
    const url = `${process.env.GATSBY_API_URL}/branches`;
    const branchData: BranchData[] = await HttpService.get(url);
    const timetradeCodes = branchData
        .reduce((timetradeCodesAcc, branchData) => {
            if (branchData.timetrade_code) {
                timetradeCodesAcc[branchData.branch_id] = branchData.timetrade_code;
            }
            return timetradeCodesAcc;
        }, {});
    return timetradeCodes;
}

async function getIFrameOptions() {
    var iframe = 'https://www04.timetrade.com/app/mtnamercu/workflows/mtnamercuworkflow001/schedule?';
    // These are the query stings that we'll look for.
    //svc = service code (Kronos)
    //(i)loc = location code (Kronos)
    // locationId (TimeTrade)
    // appointmentTypeGroupId (TimeTrade)
    // appointmentTypeId (TimeTrade)
    // resourceId (TimeTrade)
    const a = ['svc', 'loc', 'iloc', 'locationId', 'appointmentTypeGroupId', 'appointmentTypeId', 'resourceId'];
    const services = { '12': '401k_rollover_in_branch', '17': 'business_new_account_in_branch', '19': 'business_retirement_in_branch', '20': 'commercial_real_estate_in_branch', '15': 'mortgage_construction_loan_in_branch', '14': 'mortgage_refinance_in_branch', '13': 'mortgage_new_purchase_in_branch', '10': 'retirement_planning_in_branch', '16': 'support_biz_in_branch', '18': 'sba_in_branch', '4': 'vehicle_loan', '2': 'savings_account', '7': 'notary', '6': 'other_loans', '1234': 'personal_financial_counseling', '3': 'new_account_other', '1': 'checking_account', '5': 'credit_cards', '8': 'fraud_resolution', '9': 'life_events_other' };
    const serviceGroups = { '12': '401k_rollover_in_branch', '15': 'mortgage_in_branch', '14': 'mortgage_in_branch', '13': 'mortgage_in_branch', '10': 'retirement_planning_in_branch', '4': 'loans_in_branch', '2': 'services_in_branch', '7': 'services_in_branch', '6': 'loans_in_branch', '1234': 'personal_financial_counseling_virtual', '3': 'new_acct_in_branch', '1': 'new_acct_in_branch', '5': 'loans_in_branch', '8': 'services_in_branch', '9': 'services_in_branch' };
    const branches = await getBranchesMappings();

    function getParameterByName(name: string, url?: string) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // Create the array, and then load it with non-null query strings.
    const qS = {};
    for (let i = 0; i < a.length; i++) {
        var b = getParameterByName(a[i]);
        if (b) {
            if (a[i] == 'svc' || a[i] == 'loc' || a[i] == 'iloc') {
                switch (a[i]) {
                    case 'svc':
                        qS['appointmentTypeId'] = services[b];
                        qS['appointmentTypeGroupId'] = serviceGroups[b];
                        break;

                    case 'loc':
                    case 'iloc':
                        qS['locationId'] = branches[b];
                        break;
                }
            } else {
                qS[a[i]] = b;
            }
        }
    }

    // Add the query strings to the iframe URL.
    for (let prop in qS) {
        iframe += '&' + prop + '=' + qS[prop];
    }

    //Add additional text for certain product types.
    var svc = qS['svc'];
    let additional = '';

    switch (svc) {
        case '1':
            additional = 'Select your nearest branch below to schedule an appointment with a checking account expert.';
            break;
        case '4':
            additional = 'Select your nearest branch below to schedule an appointment with a vehicle loan expert.';
            break;
        case '5':
            additional = 'Select your nearest branch below to schedule an appointment with a credit card expert.';
            break;
    }

    return { src: iframe, additional }
}